import { useEffect, useState } from 'react';
import { setSession } from '../../reducetool/features/sessionSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card
} from "reactstrap";
import Select from 'react-select';
import { setOpenIpoModal } from '../../reducetool/features/uiSlice';
import { apiService } from '../../constants/ApiService';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { toast } from 'react-toastify';

const SessionSelection = ({ open }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [errMsg, setErrMsg] = useState('');
  const [errorMessage, setErrorMessage] = useState({});
  const sessions = Array.from(
    { length: 5 },
    (_, i) => `${currentYear - i}-${(currentYear - i + 1).toString()}`,
  );

    const [selectionData, setSelectionData] = useState({
    vender_id: '',
    branch_id: '',
    selectedSession: ''
  });

   const GetSystemRecordsData = async () => {
      try {
        const response = await apiService.get(
          `api/SystemRecord/GetSystemRecordsById?branchId=${selectionData.branch_id}`,
        );
        if (response.status === true) {
          return response.systemRecordsDataById;
          // setSystemData(response.systemRecordsDataById);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
        toast.error('Something went wrong while fetching system data.');
      }
    };

  const [selectedSession, setSelectedSession] = useState('');
  const [sessionOptions, setSessionOptions] = useState([]);

  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  // -----------------------------
  // ✅ Session dropdown loader
  // -----------------------------
const fetchSessions = async (searchText = '') => {
  try {
    const res = await apiService.get(
      `api/SessionMaster/GetAllSession?&search=${encodeURIComponent(
        searchText || '',
      )}`,
    );

    const container = res?.data ?? res;

    const list =
      (Array.isArray(container?.data) && container.data) ||
      (Array.isArray(container?.Data) && container.Data) ||
      (Array.isArray(container) && container) ||
      [];

    const opts = list
      .map((x) => {
        const name =
          x.session_name ??
          x.sessionName ??
          x.session_year ??
          x.sessionYear ??
          '';

        const sessionStr = String(name || '').trim();

        return sessionStr
          ? {
              value: sessionStr,
              label: sessionStr,
            }
          : null;
      })
      .filter(Boolean);

    const unique = Array.from(
      new Map(opts.map((o) => [o.value, o])).values(),
    );

    setSessionOptions(unique);

    // ✅ Auto-select first option
    if (unique.length > 0 && !selectionData.session_year) {
      setSelectionData((prev) => ({
        ...prev,
        session_year: unique[0].value,
      }));
    }
  } catch (err) {
    console.error(err);
    setSessionOptions([]);
  }
};
  // -----------------------------
  useEffect(() => {
    fetchSessions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async () => {
    //  console.log('selectedSession');

    if (selectionData.session_year) {
    if (selectionData.session_year) {
      //console.log(selectedSession)
      const systemData = await GetSystemRecordsData();
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // Months are 0-based in JS

      // Determine the current session (April to March)
      const currentSession =
        currentMonth >= 4
          ? `${currentYear}-${currentYear + 1}`
          : `${currentYear - 1}-${currentYear}`;

      // Define allowed date range
      const startYr = parseInt(selectionData.session_year.split('-')[0]);
      const endYr = parseInt(selectionData.session_year.split('-')[1]);

      const minDate = new Date(startYr, 3, 1)
        .toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
        .split('T')[0]; // 01-04-YYYY
      const maxDate = new Date(endYr, 2, 31)
        .toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
        .split('T')[0]; // 31-03-YYYY+1

      // Default date logic
      const defaultDate =
        selectionData.session_year === currentSession
          ? currentDate
            .toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
            .split('T')[0] // Current date if session matches
          : minDate; // 01-04-YYYY if session is different

      dispatch(
        setSession({
          session_id: 1,
          systemData: systemData,
          session_year: selectionData.session_year,
          vender_id: selectionData.vender_id,
          branch_id: selectionData.branch_id,
          session_start_yr: startYr,
          session_end_yr: endYr,
          session_start_date: minDate,
          session_end_date: maxDate,
          defaultDate: defaultDate,
          currentDate: currentDate
        }),
      );
      //navigate('/starter');
      closeModal();
    } else {
      setErrMsg('Please select a session to proceed further');
    }
  };
}

  const closeModal = () => { dispatch(setOpenIpoModal(false)); }

  return (
    <>
      <Modal backdrop="static" keyboard={false} isOpen={open} toggle={closeModal} size="lg" centered>
        <ModalHeader toggle={closeModal}>
          Select School Session
        </ModalHeader>

        <ModalBody>


          <VendorBranchSelector
            user={user}
            selectionData={selectionData}
            setSelectionData={setSelectionData}
            errorMessage={errorMessage}
            accessButton={true}
          />

          <Card className='card-box pd-20 mb-20'>
            
          <label>Choose the academic session from below:</label>

          <Select
            options={sessionOptions}
            value={
              sessionOptions.find(
                (o) => String(o.value) === String(selectionData.session_year),
              ) || null
            }
            // onChange={(opt) =>
            //   setSelectedSession(opt ? String(opt.value) : '')
            // }
             onChange={(opt) =>
              setSelectionData((prev)  => ({
                ...prev,
                session_year: opt ? String(opt.value) : ''
             }))
            }

            onInputChange={(val, meta) => {
              if (meta.action === 'input-change') fetchSessions(val);
            }}
            isClearable
            isSearchable
            placeholder='Type and Choose a Session...'
          />

          </Card>

          {/* <div className='input-group'>
                      <select
                        placeholder='Enter Password'
                        name='user_pass'
                        value={selectedSession}
                        onChange={(e) => setSelectedSession(e.target.value)}
                        className='custom-select'
                      >
                        <option value=''>-Select-</option>
                        {sessionOptions.map((session) => (
                          <option key={session.value} value={session.value}>
                            {session.value}
                          </option>
                        ))}
                      </select>
                    </div> */}

          {errMsg && <div className='text-danger'>{errMsg}</div>}


        </ModalBody>

        <ModalFooter>
          <button
            className="btn btn-primary"
            onClick={(e) => {
              handleSubmit(e);
              closeModal(); // close after save
            }}
          >
            <i className="fa fa-check-circle mr-1"></i>
            Save & Apply
          </button>

          <button className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>

    </>
  );
};

export default SessionSelection;
